<template>
  <div>
    <div v-bind:class="{ 'modal':true, 'show':show }">
      <div class="modal-container">
        <div class="modal-content">
        <div class="loader" v-show="loading">
          <i class="fa fa-spinner fa-spin fa-lg"></i>
          <h3>LOADING GEOFENCES SERVICE AREA...</h3>
        </div>
          <div v-show="!loading">
            <h3>Select service area you want to apply with the same promo period.</h3>
            <p><strong>Start Date: </strong> {{startDate.split(' ')[0]}}</p>
            <p><strong>End Date: </strong> {{endDate.split(' ')[0]}}</p>
            <ul>
              <li v-for="(geofence, index) in geofences" :key="index">
                <label>
                  <input type="checkbox" v-model="services" :value="geofence.id">
                  {{geofence.name}}
                </label>
              </li> 
            </ul>        
          <section class="buttons-section">
            <div class="button cta large cta secondary" @click="closeModal">Cancel</div>
            <div class="button cta large" @click="savePromo">Save</div>
          </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loading: true,
      geofences: [],
      services: [],
      geofenceType: 'servicearea'
    }
  },
  computed: {
    show () { return this.$store.state.geofences.services.show },
    startDate () { return this.$store.state.geofences.services.startDate },
    endDate () { return this.$store.state.geofences.services.endDate },
    serviceID () { return this.$store.state.geofences.services.id }
  },
  methods: {
    closeModal () {
      let self = this
      self.services = []
      self.$store.commit('geofences/setShowServiceAreaModal', false)
    },
    savePromo () {
      let self = this
      self.$sdk.post('/geofences/discount', {
        token: self.$store.state.session.sessionToken,
        geofenceId: self.services,
        promotionStartDate: self.$store.state.geofences.services.startDate,
        promotionEndDate: self.$store.state.geofences.services.endDate
      }, r => {
        if (r.error) {
          console.log('ERROR', r)
          return
        }
        // self.applyFilters(true)
        self.$store.commit('geofences/setRefreshList', true)
        self.closeModal()
        self.$store.commit('geofences/setSaveBtn', true)
      })
    },
    loadGeofences () {
      let self = this
      self.loading = true
      self.geofence = []

      let request = {
        token: self.$store.state.session.sessionToken,
        status: 'active',
        type: 'servicearea',
        pageNum: 1,
        pageSize: -1,
        order: 'priority'
      }

      self.$sdk.get('/geofences/search', request, r => {
        self.loading = false
        if (r.error) {
          console.log("error")
          self.$store.commit('geofences/setShowGeofencePriority', false)
          return
        }

        self.geofences = r.list
      })
    },
    applyFilters (refresh) {
      let self = this
      let request = {
        token: self.$store.state.session.sessionToken,
        status: self.geofenceStatus,
        pageNum: self.pageNum,
        pageSize: self.pageSize,
        order: 'priority'
      }
      if (refresh) { request.pageNum = 1 }
      if (self.geofenceType !== '') {
        request['type'] = self.geofenceType
      }
      self.$store.commit('geofences/setGeofenceLoading', true)
      self.$sdk.get('/geofences/search', request, r => {
        self.$store.commit('geofences/setGeofenceLoading', false)
        if (r.error) {
          // SHOW ERROR
          return
        }

        let result = []
        for (let i = 0; i < r.list.length; i++) {
          let item = r.list[i]
          item['showForm'] = false
          item['isP2P'] = false
          if (item.pricing.SharedAirportFee === null) {
            item.pricing.SharedAirportFee = 0
          }
          if (item.pricing.OpoliAirportFee === null) {
            item.pricing.OpoliAirportFee = 0
          }
          if (item.pricing.BlackAirportFee === null) {
            item.pricing.BlackAirportFee = 0
          }
          if (item.pricing.SUVAirportFee === null) {
            item.pricing.SUVAirportFee = 0
          }
          if (item.pricing.PrivateShuttleAirportFee === null) {
            item.pricing.PrivateShuttleAirportFee = 0
          }

          if (typeof item.services === 'undefined' || item.services === null) {
            item['services'] = {
              shared: {
                allowed: false,
                curbside: false,
                meetAndGreet: false,
                pickupFee: 0
              },
              opoli: {
                allowed: false,
                curbside: false,
                meetAndGreet: false,
                pickupFee: 0
              },
              black: {
                allowed: false,
                curbside: false,
                meetAndGreet: false,
                pickupFee: 0
              },
              suv: {
                allowed: false,
                curbside: false,
                meetAndGreet: false,
                pickupFee: 0
              },
              shuttle: {
                allowed: false,
                curbside: false,
                meetAndGreet: false,
                pickupFee: 0
              },
            }
          }
          result.push(item)
        }
        self.$store.commit('geofences/setGeofenceItems', result)

        self.pageNum = r.paging.pageNum
        let totalPages = (Math.floor(r.paging.totalItems / self.pageSize) + ((r.paging.totalItems % self.pageSize) > 1 ? 1 : 0))
        self.pageTotal = totalPages
      })
    }
  },
  watch: {
    show (value){
      let self = this
      if (!value) {
        self.geofences = []
        return
      }
      if(!self.services.length){
        self.services.push(self.$store.state.geofences.services.id)
      }
      self.loadGeofences();
    }
  }

}
</script>

<style lang="scss" scoped>
.modal {
  position: fixed;
  z-index: 999;
  top: -100%;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.3);
  // display: table;
  opacity: 0;
  transition: all 250ms;
  overflow: auto;

  &.show{
    top: 0;
    opacity: 1;
  }
}

.modal-container {
  display: table;
  width: 100%;
  height: 100%;
  padding: 35px;
}

.modal-content {
  vertical-align: middle;
  position: relative;
  background-color: #fff;
  border-radius: 3px;
  max-width: 960px;
  margin: 0 auto;
  box-shadow: 0 2px 8px rgba(0,0,0,0.35);
  overflow: hidden;
  padding: 25px;

  p{
    margin: 0;
    font-size: 14px;
    color: #444;
  }
  b{ font-size: 15px; }
  .button{
    margin-top: 25px;
  }

  ul {
    list-style: none;
    padding-left: 0;
    -webkit-column-count: 4; /* Chrome, Safari, Opera */
    -moz-column-count: 4; /* Firefox */
    column-count: 4;

    li {
      font-size: 14px;
      margin-bottom: 8px;
      line-height: 135%;

      label{ cursor: pointer; }
      input {
        width: inherit;
        display: inline-block;
        margin: 0 5px 0 0;
      }
    }
  }
  .loader {
    text-align: center;
    padding: 30px 0 0;
  }

  .buttons-section {
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Geofences/Modal.vue